/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientTicketDto } from '../../models/client-ticket-dto';
import { UpdateClientTicketDto } from '../../models/update-client-ticket-dto';

export interface ClientTicketControllerCancel$Params {
  ticketId: string;
  vendorWorkspaceId: string;
      body: UpdateClientTicketDto
}

export function clientTicketControllerCancel(http: HttpClient, rootUrl: string, params: ClientTicketControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketDto>> {
  const rb = new RequestBuilder(rootUrl, clientTicketControllerCancel.PATH, 'patch');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.path('vendorWorkspaceId', params.vendorWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientTicketDto>;
    })
  );
}

clientTicketControllerCancel.PATH = '/api/client-ticket/{vendorWorkspaceId}/{ticketId}';
